import React, { useState, useEffect } from 'react';
import { updateDoctor } from '../../logic/settings';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { Form, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clearStorage } from './../../libs/general';

function DoctorFields() {
	const navigate = useNavigate();
	const location = useLocation();
	const params = useParams();
	const [doc, setDoc] = useState(null);
	const [error, setError] = useState('');
	
	useEffect(() => {
		if (location && location.state && location.state.doc) {
			const { doc } = location.state;
			// Ensure docId is present - use URL param as fallback if missing
			const docWithId = { ...doc };
			if (!docWithId.docId && params.docId) {
				docWithId.docId = params.docId;
			}
			setDoc(docWithId);
			
			if (!(docWithId.preferences && docWithId.preferences.fields
				&& docWithId.preferences.fields instanceof Array
				&& docWithId.preferences.fields.length > 0)) {
				// Use functional update to ensure we have the latest doc state
				setDoc(prevDoc => {
					const currentDoc = prevDoc || docWithId;
					if (!currentDoc.preferences) currentDoc.preferences = {};
					if (!currentDoc.preferences.fields) currentDoc.preferences.fields = [];
					if (currentDoc.preferences.fields.length === 0) {
						currentDoc.preferences.fields.push(
							{ fieldName: 'firstname', visible: false, required: false },
							{ fieldName: 'lastname', visible: false, required: false },
							{ fieldName: 'idcard', visible: false, required: false },
							{ fieldName: 'mobilenumber', visible: false, required: false },
							{ fieldName: 'landlinenumber', visible: false, required: false },
							{ fieldName: 'email', visible: false, required: false },
							{ fieldName: 'dob', visible: false, required: false }
						);
					}
					return { ...currentDoc };
				});
			}
		}
	}, [location, params.docId]);
	
	const handleChange = (e, i) => {
		if (e && e.target && e.target.id) {
			// Extract the field name (visible or required) from the ID
			const fieldId = e.target.id.split('-')[0];
			const value = e.target.checked;

			const updatedDoc = {...doc};
			updatedDoc.preferences.fields[i][fieldId] = value;
			setDoc(updatedDoc);
		} else return;
	};
	
	const handleSave = async (e) => {
		e.preventDefault();
		e.stopPropagation();

		// Ensure docId is present - use URL param as fallback if missing from doc object
		const docToSave = { ...doc };
		if (!docToSave.docId && params.docId) {
			docToSave.docId = params.docId;
		}

		const updatedDoc = await updateDoctor(docToSave);
		clearStorage();

		if (updatedDoc instanceof Error)
			handleError(updatedDoc);
		else
			navigate("/settings/doctors");
	};
	
	const handleError = (e) => {
		console.log(e);
		setError(e);
	};
	
	const addFields = () => {
		const updatedDoc = {...doc};

		if (!updatedDoc.preferences) updatedDoc.preferences = {};
		if (!updatedDoc.preferences.fields) updatedDoc.preferences.fields = [];

		updatedDoc.preferences.fields.push(
			{
				fieldName: 'firstname',
				visible: false,
				required: false
			},
			{
				fieldName: 'lastname',
				visible: false,
				required: false
			},
			{
				fieldName: 'idcard',
				visible: false,
				required: false
			},
			{
				fieldName: 'mobilenumber',
				visible: false,
				required: false
			},
			{
				fieldName: 'landlinenumber',
				visible: false,
				required: false
			},
			{
				fieldName: 'email',
				visible: false,
				required: false
			},
			{
				fieldName: 'dob',
				visible: false,
				required: false
			});
		setDoc(updatedDoc);
	};
	
	// Only render if doc is loaded
	if (!doc) return <div>Loading...</div>;
	
	return (
		<div>
			<div className="pages__back-button--container">
				<FontAwesomeIcon className="pages__back-button--icon" icon="chevron-left"></FontAwesomeIcon>
				<Link className="pages__back-button--text" to="/settings/doctors">Back</Link>
			</div>
			<div className="pages__modal--container">
				<header className="pages__header--container">
					<h1>Doctor's Fields</h1>
				</header>
				<Container>
					<form className="pages__form" autoComplete='on' onSubmit={handleSave} style={{ paddingBottom: '60px' }}>
						<Row className="pages__form--fieldset fields_settings__form--fieldset">
							<Col className="fields_settings__form--field-title-container"
								xs={{ span: 4, offset: 3 }} sm={{ span: 4, offset: 3 }} md={{ span: 4, offset: 3 }} lg={{ span: 4, offset: 3 }}>
								<p className="field_settings__form--field-title">Visible</p>
							</Col>
							<Col className="fields_settings__form--field-title-container"
								xs={{ span: 4, offset: 1 }} sm={{ span: 4, offset: 1 }} md={{ span: 4, offset: 1 }} lg={{ span: 4, offset: 1 }}>
								<p className="field_settings__form--field-title">Required</p>
							</Col>
						</Row>
						{
							(doc.preferences && doc.preferences.fields
								&& doc.preferences.fields instanceof Array
								&& doc.preferences.fields.length >= 1) ?
								doc.preferences.fields.map((field, i) => {
									return (
										<Row className="pages__form--row fields_settings__form--row" key={i}>
											<Col xs={{ span: 3, offset: 2 }} sm={{ span: 3, offset: 2 }} md={{ span: 3, offset: 2 }} lg={{ span: 3, offset: 2 }}>
												<p className="field_settings__form--field-name">{field.fieldName}</p>
											</Col>
											<Col xs={3} sm={3} md={3} lg={3}>
												<Form.Group className="pages__form--item">
														<Form.Check
															id={`visible-${i}`}
															type="checkbox"
															checked={field.visible}
															onChange={(e) => handleChange(e, i)}
															custom
														/>
												</Form.Group>
											</Col>
											<Col xs={3} sm={3} md={3} lg={3}>
												<Form.Group className="pages__form--item">
														<Form.Check
															id={`required-${i}`}
															type="checkbox"
															checked={field.required}
															onChange={(e) => handleChange(e, i)}
															custom
														/>
												</Form.Group>
											</Col>
										</Row>
									)
								})
								: null
						}
						<div className="pages__form--error">
							{
								error && error instanceof Array ?
									error.map((err, i) => <p key={i}>{err.toString()}</p>)
									: <p>{error.message}</p>
							}
						</div>
						<input className="save-button" type='submit' value="Save" />
					</form>
				</Container>
			</div>
		</div>
	);
}

export default DoctorFields;